module.exports = __webpack_public_path__ + "public/viewMessage/star.svg?897dd6bd";